let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ktols")).then(() => parcelRequire('9yniG'));